module.exports = __webpack_public_path__ + "static/media/mobileFrame.91cd23d3.png";